var h = Object.defineProperty;
var p = (o, t, r) => t in o ? h(o, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[t] = r;
var n = (o, t, r) => p(o, typeof t != "symbol" ? t + "" : t, r);
class b {
  /**
   * Creates an instance of CollapseVanilla.
   * @param {CollapseVanillaConfig} [config={}] - The configuration object.
   * @param {boolean} [config.enableLogErrors=false] - Whether to enable logging of errors to the console.
   */
  constructor(t = {}) {
    n(this, "enableLogErrors");
    this.enableLogErrors = t.enableLogErrors ?? !1, this.initialize();
  }
  /**
   * Initializes the collapse functionality by adding click event listeners to toggle elements.
   * @private
   */
  initialize() {
    document.querySelectorAll(
      "[data-hz-collapse-target]"
    ).forEach((r) => {
      r.addEventListener("click", this.handleToggleClick.bind(this));
    });
  }
  /**
   * Handles the click event on toggle elements to collapse or expand the target elements.
   * @param {Event} event - The click event.
   * @private
   */
  handleToggleClick(t) {
    var i;
    t.preventDefault(), t.stopPropagation();
    const s = (i = t.currentTarget.getAttribute("data-hz-collapse-target")) == null ? void 0 : i.replace(/:/g, "\\:");
    if (!s) {
      this.logError(
        "No `data-hz-collapse-target` attribute found on the clicked element."
      );
      return;
    }
    const l = document.querySelectorAll(s);
    if (!l || l.length === 0) {
      this.logError(`No elements found with the selector: ${s}`);
      return;
    }
    const d = document.querySelectorAll(
      `[data-hz-collapse-target="${s}"]`
    ), g = (!(l[0].dataset.isExpanded === "true")).toString();
    d.forEach(
      (e) => e.setAttribute("aria-expanded", g)
    ), l.forEach((e) => {
      const a = e.dataset.isExpanded === "true", c = (!a).toString(), E = e.dataset.noAnimation === "true";
      e.dataset.isExpanded = c, e.setAttribute("aria-hidden", a.toString()), E ? e.classList.toggle("hidden", a) : e.classList.replace(
        a ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
        a ? "grid-rows-[0fr]" : "grid-rows-[1fr]"
      );
    });
  }
  /**
   * Logs an error message to the console if error logging is enabled.
   * @param {string} message - The error message to log.
   * @private
   */
  logError(t) {
    this.enableLogErrors && console.error(t);
  }
}
export {
  b as CollapseVanilla
};
